import { AppBar, Box, Grid, Toolbar, useTheme } from "@mui/material";
import {
	BackdropCircularProgress,
	EmptyList,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import {
	EMPLOYEE_LIST_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import { FormProvider, useForm } from "react-hook-form";
import { GET_QUERY_KEY, QUERY_OPTIONS } from "../../../../common/constants";
import { IResponse, IServerError } from "../../../../models/common";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
	formatDate,
	savePdfAsFile,
	sortDDLByLabel,
	useNavigateToLogout,
	useRemoveQueriesOnUnmount,
} from "../../../../common/Common";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { EmployeeService } from "../../../../services/EmployeeService";
import { IAppState } from "../../../../store/reducers";
import { IDropDownListResponse } from "../../../../models/common/IDropDownListResponse";
import { IGetListRequest } from "../../../../models";
import { ReportsService } from "../../../../services/ReportsService";
import { StubReportDataGridWithColumnToggled } from "./StubReportDataGridWithColumnToggled";
import { StubReportHeader } from "../StubReport/StubReportHeader";
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";
import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface IStubReport { }
const STUB_REPORT_QUERY_KEY = "stub-report";

const useStubReport = (
	runGetListAPICall: boolean,
	clientId: string,
	employeeId: string,
	startDate: string | null,
	endDate: string | null,
	params: IGetListRequest, // must be serializable/stable,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			STUB_REPORT_QUERY_KEY,
			runGetListAPICall,
			clientId,
			employeeId,
			startDate,
			endDate,
			params, // make sure params is stable (memoized or primitive values)
		],
		queryFn: () =>
			ReportsService.getStubReport(
				runGetListAPICall,
				clientId,
				employeeId,
				startDate,
				endDate,
				params,
				navigateToLogout,
			),
		refetchOnWindowFocus: false,
	});

const useGetEmployeeDDL = (clientId: string) =>
	useQuery({
		queryKey: ["employee-status-ddl", clientId],
		queryFn: () => {
			return EmployeeService.getEmployeeDDL(clientId);
		},
		refetchOnWindowFocus: false,
	});


export const StubReport: React.FC<IStubReport> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const clientIdStore = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const clientName = useSelector((state: IAppState) => state.client.clientName);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const [runGetListAPICall, setRunGetListAPICall] =
		useState<any>(true);
	const [stubReportData, setStubReportData] =
		useState<any>(undefined);
	const [selectedIds, setSelectedIds] = useState([])


	const { isLoading: isLoadingEmployeeDDL, data: employeeDDL } = useGetEmployeeDDL(clientId);

	const formMethods = useForm<any>({
		// resolver: yupResolver(ValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
	});

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "firstName",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const employeeId = formMethods.getValues("employee");
	const startDate = formMethods.watch("startDate");
	const endDate = formMethods.watch("endDate");


	const { isPending, data } = useStubReport(
		runGetListAPICall,
		clientIdStore,
		employeeId && employeeId,
		formatDate(startDate),
		formatDate(endDate),
		queryParams,
		navigateToLogout
	);
	const stubReportList: any | null = data;

	useEffect(() => {
		if (stubReportList) {
			setStubReportData(stubReportList);
		}
	}, [stubReportList]);

	//   after click apply button api calls with updated values and update stub report data
	const stubReportDataAPICall = (
		employeeId: string,
		startDate: string,
		endDate: string,
	) => {
		const fetchData = async () => {
			setIsLoading(true);
			try {
				const response: any = await ReportsService.getStubReport(
					true,
					clientIdStore,
					employeeId,
					formatDate(startDate),
					formatDate(endDate),
					queryParams,
					navigateToLogout
				);

				if (response) {
					setStubReportData(response);
				}
			} catch {
			} finally {
				setIsLoading(false);
			}
		};
		fetchData();
	};

	const onSubmit = (values: any) => {
		stubReportDataAPICall(
			values.employee,
			values.startDate,
			values.endDate,
		)
	};


	// 	const employeeDDLItems = useMemo(() => {
	// 	if (employeeDDL) {
	// 		if (
	// 			employeeDDL &&
	// 			Array.isArray(employeeDDL)
	// 		) {
	// 			let resources: IDropDownListResponse[] =
	// 				employeeDDL.map(
	// 					(resourceItem: IDropDownListResponse) => ({
	// 						// id: resourceItem.id,
	// 						label: resourceItem.label,
	// 						value: resourceItem.value,
	// 					})
	// 				);

	// 			resources.unshift({
	// 				label: "All",
	// 				value: "all",
	// 			});

	// 			return resources;
	// 		}
	// 		return [];
	// 	}
	// }, [employeeDDL]);

	const [zeroEmployee, setzeroEmployee] = useState(true);
	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
		setRunGetListAPICall(true)
	}, []);



	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	useRemoveQueriesOnUnmount(["employee-report"]);

	const updatedStubReportListItems = useMemo(() => {
		return (
			stubReportData &&
			stubReportData.items &&
			stubReportData?.items.map((item: any) => ({
				...item,
			}))
		);
	}, [stubReportData]);

	// getting latest updated values of form fields using watch method
	const { watch } = formMethods;

	const expandedLabels = ["Reports", "Employees"];
	const expandedStubReportOrSetupItem = "Stub"; // Special case for "List" under "Employee"
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Employees" &&
				item.label === expandedStubReportOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedStubReportOrSetupItem && "/reports/stub",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: EMPLOYEE_LIST_SCREEN_SLUG,
				accountantName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: true }));

		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
	}, [drawerMenuOptions]);

	const onDownloadClickedHandler = async (params: any) => {
		const payPeriodEndDate = formatDate(params.payPeriodEndDate);
		// alert(payPeriodEndDate);
		(async () => {
			try {
				setIsLoading(true)
				const response: any =
					await ReportsService.getDownloadStubListData(employeeId, clientId, formatDate(startDate), formatDate(endDate), [payPeriodEndDate]);
				if (response) {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `file.pdf`;
						savePdfAsFile(response, filename);
					}
				}
				// queryClient.invalidateQueries({ queryKey: [IN_PROCESS_COLLECTION_TRANSACTIONS_QUERY_KEY] })
			} catch { } finally { setIsLoading(false) }
		})();
	}

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);

		if (selectedItems.length) {
			return (
				<Box sx={{ marginRight: theme.spacing(2) }}>
					<EnhancedButtonPrimeReact
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						label="Download"
						onClickHandler={() => {
                        const selectedDates = selectedItems.map((item: any) => 
                            formatDate(item.payPeriodEndDate) 
                        );
                        onDowloadMultipleStubClickedHandler(selectedDates);
                    }}
					/>
				</Box>
			);
		}
		return (
			<></>
		);
	}, [employeeId, clientId, startDate, endDate]);

	const onDowloadMultipleStubClickedHandler = async (selectedPayPeriodEndDates:string[]) => {
		(async () => {
			try {
				setIsLoading(true)
				const response = await ReportsService.getDownloadStubListData(employeeId, clientId, formatDate(startDate), formatDate(endDate), selectedPayPeriodEndDates);
				if (response) {
					if (response.status === 400) {
						setSnackbarData({
							open: true,
							message: response.data.message
								? response.data.message
								: "Something went wrong.",
							severity: "error",
						});
					} else {
						const filename = `file.pdf`;
						savePdfAsFile(response, filename);
					}
				}
			} catch { } finally { setIsLoading(false) }
		})()
	}

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",
				}}
			>
				{"Stub Report"}
			</div>

			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<StubReportHeader
						employeeDDLItems={employeeDDL && sortDDLByLabel(employeeDDL)}
						setStateRunGetListAPICall={(value: boolean) => setRunGetListAPICall(value)}
					/>
				</form>
			</FormProvider>

			<Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
				<BackdropCircularProgress
					open={
						isPending || isLoadingEmployeeDDL || isLoading
					}
					testId="stub-report"
				/>

				<StubReportDataGridWithColumnToggled
					columns={
						stubReportData && stubReportData.headerColumns
							? stubReportData.headerColumns.filter(
								(item: any) => item.field !== "id"
							)
							: []
					}
					completeHeaderColumnsList={
						stubReportData?.headerColumns ?? []
					}

					rows={
						stubReportData && updatedStubReportListItems
							? updatedStubReportListItems
							: []
						// stubReportData?.items ?? []
						// itams
					}
					showIndexColumn={true}
					showChecboxColumn={true}
					showSettingColumn={false}

					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						stubReportData && stubReportData.total
							? stubReportData.total
							: 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}

					changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
						setzeroEmployee(value)
					}
					pageTitle={"Stub Report"}
					onDownloadClickedHandler={onDownloadClickedHandler}
					selectionToolbar={selectionToolbar}

				/>

				{stubReportData ? (
					<AppBar
						position="sticky"
						color="default"
						elevation={1}
						sx={{
							backgroundColor: "#F7F7F7",

							boxShadow: "none",
							alignItems: "center",
							zIndex: 0,
							position: "sticky",
							bottom: 0,
						}}
					></AppBar>
				) : (
					<></>
				)}
			</Grid>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={`snackbar`}
				open={snackbarData.open}
			/>
		</>
	);
};
